module.exports = {
	model: {
		options: {}
	},

	methods: {
		sanitizeResources: function(storage){
			var n, newsletter, nt, newsletterTemplate, template, tt, templatesTrl, langDependentTemplate;
			var value;
			var newsletterID, templateID;

			const langCode = storage.langCode || appConfig.language.default || 'de-at'
			var options = {};
			this.model.options = [];

			for(n in (this.model['resource-picker-data'] || {}).options || []){
				newsletter = (this.model['resource-picker-data'].options[n] || {}).resource || {};
				options = {};

				for(nt in ((newsletter.children || {}).nl_newsletters_templates || {}).data || []){
					newsletterTemplate = newsletter.children.nl_newsletters_templates.data[nt] || {};
					template = ((newsletterTemplate.children || {}).cms_templates || {}).data || {};
					langDependentTemplate = false;

					for(tt in ((template.relationships || {}).cms_templatesTrl || {}).data || []){
						templatesTrl = template.relationships.cms_templatesTrl.data[tt] || {};

						if((templatesTrl.attributes || {}).langCode === langCode){
							langDependentTemplate = templatesTrl;
							break;
						}
					}

					if(
						(newsletterID = ((newsletter.attributes || {}).newsletterID || 0))
						&&
						(templateID = ((template.attributes || {}).templateID || 0))
					){
						value = newsletterID + '_' + templateID;

						if(langDependentTemplate){
							options[value] = ((langDependentTemplate || {}).attributes || {}).name || 'UNKNOWN TRL NAME'
						} else {
							options[value] = ((template || {}).attributes || {}).name || 'UNKNOWN NAME'
						}
					}
				}

				this.model.options.push({
					title: (newsletter.attributes || {}).name || 'UNKNOWN NEWSLETTER',
					options: options
				});
			}
		}
	}
}